{
	"labels": {
		"izberi": "Izberi jezik",
		"buttons": {
			"odpriJezik": "Nastavi jezik",
			"potrdiJezik": "Spremeni",
			"generiranje": "Spreminjanje"
		}
	},
	"obvestila": {
		"vprasanjeMenjave": "Spremnili boste prikazni jezik aplikacije. Ali želite zamenjati jezik?",
		"uspesno": "Jezik uporabniškega vmesnika uspešno spremenjen",
		"napakaPosodabljanja": "Napaka pri posodabljanju podatkov"
	}
}